// extracted by mini-css-extract-plugin
export default {"list":"SearchList_list__cvbxx","list__flat":"SearchList_list__flat__buE-c","list__emptyState":"SearchList_list__emptyState__kIA2a font-md-regular"};